// extracted by mini-css-extract-plugin
export default {"container":"TermAndCourseStats_container__Y23E+","block":"TermAndCourseStats_block__lebsH","title":"TermAndCourseStats_title__8sKH-","info":"TermAndCourseStats_info__zFEv+"};